import { defineMessages } from 'react-intl';

export const message = defineMessages({
  welcomeToPandoraPremium: {
    id: 't.welcomeToPandoraPremium',
    defaultMessage: 'Welcome to Pandora Premium!',
  },
  pandoraPremiumFeatures: {
    id: 't.pandoraPremiumFeatures',
    defaultMessage:
      'With Pandora Premium, you can search and play your favorite songs, create playlists, and keep enjoying personalized stations.',
  },
  getStarted: {
    id: 't.getStarted',
    defaultMessage: 'Get Started',
  },
  anonWelcomeTitle: {
    id: 't.anonWelcomeTitle',
    defaultMessage: 'Keep enjoying Pandora for free.',
  },
  anonWelcomeBody: {
    id: 't.anonWelcomeBody',
    defaultMessage: 'Sign up for a free Pandora account now to keep the music playing.',
  },
  anonWelcomeSubText: {
    id: 't.anonWelcomeSubText',
    defaultMessage: 'Already have a Pandora account? {logIn}',
  },
} as const);
